import { render } from "./updatePaymements.vue?vue&type=template&id=7b6fd02c&scoped=true"
import script from "./updatePaymements.vue?vue&type=script&lang=js"
export * from "./updatePaymements.vue?vue&type=script&lang=js"

import "./updatePaymements.vue?vue&type=style&index=0&id=7b6fd02c&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/cleanshift_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6fd02c"]])

export default __exports__